import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "../../hooks";
function activeIndex(step) {
    switch (step) {
        case "phone":
        case "otp":
            return 0;
        case "appointment-form":
        case "patient-selection":
            return 1;
        case "summary":
        case "payment":
            return 2;
        default:
            return -1;
    }
}
export function StepIndicator({ currentStep, labels, }) {
    const { t } = useTranslation("appointment");
    const idx = activeIndex(currentStep);
    const theme = useTheme();
    const isNarrow = useMediaQuery(theme.breakpoints.down("sm"));
    const defaultSteps = [
        {
            full: t("stepVerifyNumber", "Verify your Number"),
            short: t("stepVerifyShort", "Verify"),
        },
        {
            full: t("stepInformation", "Information"),
            short: t("stepInfoShort", "Info"),
        },
        {
            full: t("stepPayment", "Payment"),
            short: t("stepPayment", "Payment"),
        },
    ];
    const steps = labels
        ? labels.map((full) => ({ full, short: full }))
        : defaultSteps;
    if (idx < 0)
        return null;
    return (_jsx(Box, { sx: {
            width: "100%",
            borderBottom: 1,
            borderColor: "divider",
            bgcolor: "background.paper",
            flexShrink: 0,
        }, children: _jsx(Box, { sx: {
                maxWidth: 520,
                mx: "auto",
                px: isNarrow ? 2 : 3,
                py: isNarrow ? 1.25 : 1.5,
            }, children: _jsx(Stack, { direction: "row", alignItems: "center", spacing: 0, children: steps.map((step, i) => {
                    const done = i < idx;
                    const active = i === idx;
                    const label = isNarrow ? step.short : step.full;
                    let labelColor;
                    if (active)
                        labelColor = "primary.main";
                    else if (done)
                        labelColor = "text.secondary";
                    else
                        labelColor = "text.disabled";
                    return (_jsxs(React.Fragment, { children: [_jsxs(Stack, { direction: "row", alignItems: "center", spacing: isNarrow ? 0.5 : 0.75, sx: { flexShrink: 0 }, children: [_jsx(Box, { sx: {
                                            width: isNarrow ? 22 : 26,
                                            height: isNarrow ? 22 : 26,
                                            borderRadius: "50%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: isNarrow ? 11 : 12,
                                            fontWeight: 700,
                                            lineHeight: 1,
                                            flexShrink: 0,
                                            bgcolor: done || active
                                                ? "primary.main"
                                                : "action.disabledBackground",
                                            color: done || active
                                                ? "primary.contrastText"
                                                : "text.disabled",
                                            transition: "all 0.2s",
                                        }, children: done ? "✓" : i + 1 }), _jsx(Typography, { sx: {
                                            fontSize: isNarrow ? 11 : 12.5,
                                            fontWeight: active ? 700 : 500,
                                            color: labelColor,
                                            whiteSpace: "nowrap",
                                            letterSpacing: 0,
                                        }, children: label })] }), i < steps.length - 1 && (_jsx(Box, { sx: {
                                    flex: 1,
                                    height: 1.5,
                                    mx: isNarrow ? 1 : 1.5,
                                    borderRadius: 1,
                                    bgcolor: i < idx ? "primary.main" : "action.disabledBackground",
                                    transition: "background-color 0.3s",
                                } }))] }, step.full));
                }) }) }) }));
}
